import React from "react";

const Settings = () => {
  return (
    <div>
      <div id="ClientUser" style={{margin:'20px'}}>
        <span className="header-title">Settings</span>
        <br />
        <br />
        <span class="Download-Full-Report mr-2">Sorry this feature isn't available right now!</span>
      </div>
    </div>
  );
};

export default Settings;
